
import axios from 'axios'
import qs from 'qs'
import NProgress from 'nprogress'
import store from "../store";
import global from '../globle/globle'
// 响应时间
axios.defaults.timeout = 60 * 1000 * 10
// 配置cookie
axios.defaults.withCredentials = true
// 配置请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
// 静态资源
import router from '../router/index'

// 配置接口地址
axios.defaults.baseURL = global.axiosDefaultsURL //global.axiosDefaultsURL
// POST传参序列化(添加请求拦截器)
axios.interceptors.request.use(
	config => {
		config.headers['axios'] = "1";
		config.headers['token'] = store.getters.tokenString;
		NProgress.start()
		if (config.method === 'post') {
			config.data = qs.stringify(config.data)
		}

		if (store.getters.tokenString) { // 判断是否存在token，如果存在的话，则每个http header都加上token
			config.headers['token'] = store.getters.tokenString;
		} 
		return config
	},
	err => {
		return Promise.reject(err)
	}
)
// 返回状态判断(添加响应拦截器)
axios.interceptors.response.use(
	res => {
		NProgress.done()
		return res
	},
	err => {
		NProgress.done()
		if (err.response) {
			switch (err.response.status) {
				case 302:
					break;
			}
		}
		return Promise.reject(err)
	}
) 


//application/json请求
function applicationJson(url, params, config) {
	let axiosInstance = axios.create({
		baseURL: global.axiosDefaultsURL,
		withCredentials: true,
		headers: {
			'Content-Type': 'application/json;charset=UTF-8',
			'token':store.getters.tokenString
		}
	})

	axiosInstance.interceptors.response.use(
		res => {
			NProgress.start();
			if (res.data.code == 200 || res.data.code == 0) {
				NProgress.done();
			}
			if (res.status == 203 || res.status == 205) { //token失效
				localStorage.removeItem('token');
				router.push({
					path: '/login/login'
				})
			}

			return res
		},
		err => {
			if (NProgress) NProgress.done();

			return Promise.reject(err)
		}
	)
	return new Promise((resolve, reject) => {
		axiosInstance
			.post(url, params, config)
			.then(
				res => {
					resolve(res)
				},
				err => {
					reject(err.data)
				}
			)
			.catch(err => {
				reject(err)
			})
	})
}


function applicationJsonPrint(url, params, config) {
	let axiosInstance = axios.create({
		baseURL: global.axiosDefaultsURL,
		withCredentials: true,
		headers: {
			'Content-Type': 'application/json;charset=UTF-8',
			 'token': localStorage.getItem('token'),
		}
	})

	axiosInstance.interceptors.response.use(
		res => {
			NProgress.start();
			if (res.data.code == 200 || res.data.code == 0) {
				NProgress.done();
			}
			if (res.status == 203 || res.status == 205) { //token失效
				localStorage.removeItem('token');
				router.push({
					path: '/login/login'
				})
			}

			return res
		},
		err => {
			if (NProgress) NProgress.done();

			return Promise.reject(err)
		}
	)
	return new Promise((resolve, reject) => {
		axiosInstance
			.post(url, params, config)
			.then(
				res => {
					resolve(res)
				},
				err => {
					reject(err.data)
				}
			)
			.catch(err => {
				reject(err)
			})
	})
}



function multipartPost(url, params, config) {
  let axiosInstance = axios.create({
    baseURL: global.axiosDefaultsURL,
   headers: {
     'Content-Type': 'multipart/form-data',
   	 'token': store.getters.tokenString,

   }
  })
  axiosInstance.interceptors.response.use(
    res => {
      return res
    },
    err => {
      if(NProgress) NProgress.done();
      console.log(err)
    }
  )


  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, params, config)
      .then(
        res => {
          resolve(res)
        },
        err => {

          reject(err.data)
        }
      )
      .catch(err => {
        reject(err)
      })
  })

}


function multipartPostImageRecognition(url, params, config) {
  let axiosInstance = axios.create({
    baseURL: global.imageRecognitionURL,
   headers: {
     'Content-Type': 'multipart/form-data',
   	 'token': store.getters.tokenString,

   }
  })
  axiosInstance.interceptors.response.use(
    res => {
      return res
    },
    err => {
      if(NProgress) NProgress.done();
      console.log(err)
    }
  )


  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, params, config)
      .then(
        res => {
          resolve(res)
        },
        err => {

          reject(err.data)
        }
      )
      .catch(err => {
        reject(err)
      })
  })

}

function fetchPost (url, params,config) {
	let axiosInstance = axios.create({
	  baseURL: global.axiosDefaultsURL,
	 headers: {
	   'Content-Type': 'multipart/form-data',
	 	 'token': store.getters.tokenString,
	
	 }
	})
	axiosInstance.interceptors.response.use(
	  res => {
	    return res
	  },
	  err => {
	    if(NProgress) NProgress.done();
	    console.log(err)
	  }
	)
  return new Promise((resolve, reject) => {
    axios.post(url, params,config)
      .then(
        res => {
          resolve(res)
        },
        err => {
          reject(err)
        }
      )
      .catch(err => {
        reject(err)
      })
  })
}

const globalImgPath = global.imgPath

// application/json GET 请求（query string 由 axios 序列化）
function applicationJsonGet(url, params, config) {
	let axiosInstance = axios.create({
		baseURL: global.axiosDefaultsURL,
		withCredentials: true,
		headers: {
			'Content-Type': 'application/json;charset=UTF-8',
			'token': store.getters.tokenString
		}
	})

	axiosInstance.interceptors.response.use(
		res => {
			NProgress.start()
			if (res.data.code == 200 || res.data.code == 0) NProgress.done()
			if (res.status == 203 || res.status == 205) {
				localStorage.removeItem('token')
				router.push({ path: '/login/login' })
			}
			return res
		},
		err => {
			if (NProgress) NProgress.done()
			return Promise.reject(err)
		}
	)

	return new Promise((resolve, reject) => {
		axiosInstance.get(url, { params, ...config })
			.then(res => resolve(res), err => reject(err.data))
			.catch(err => reject(err))
	})
}

export default {
    applicationJson,
	applicationJsonGet,
	applicationJsonPrint,
	multipartPostImageRecognition,
	multipartPost,
	fetchPost,
	globalImgPath
}


